import { VariantProps, cva } from 'class-variance-authority';
import { ComponentProps } from 'react';

const styles = cva([], {
  variants: {
    variant: {
      default: [
        'block',
        'text-xs',
        'mb-1',
        'font-medium',
        'uppercase',
        'text-text-secondary',
      ],
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

type Props = ComponentProps<'label'> & VariantProps<typeof styles>;

export const Label = ({ children, variant, ...props }: Props) => {
  const generateTestId = () => {
    if (typeof children === 'string' || typeof children === 'number') {
      return `label: ${children}`;
    }

    return 'label';
  };

  return (
    <label
      className={styles({ variant })}
      {...props}
      data-testid={generateTestId()}
    >
      {children}
    </label>
  );
};
